/* eslint-disable */
import convertList from '../convertList';
import  { envDomain } from '@/common/contact-selector/utils/domainConfig'

export default function(config) {
    const moreConfig = {
        totalState: false
    };
    console.log("config------", JSON.stringify(config))

    if(config.parent.pageInfo === undefined){
        console.log("config.parent.pageInfo", config.parent)
        config.parent.pageInfo = {
            index: 0,
            end: false

        }
    }
    let pageInfo = config.parent.pageInfo

    const selfConfig = config.extendConfig;
    if (selfConfig.ajax) {
        return new Promise((resolve, reject) => {
            getOrgTree(config.groupId).then(res=>{
                if(res.code !== 0 ){
                    reject("组织架构数据获取失败", res.code)
                }
                let {deps, staffs} = res.data
                let groups = deps.map(x=>{
                    return {
                        ...x,
                        list:[],
                        // memberTotal: 10
                    }
                })

                let users = staffs.map(x=>{
                    return {
                        ...x,
                        colleagueInfo:{
                            account: x.account
                        },
                        id: x.kfext
                    }
                })

                let list = convertList(
                    [ ...users, ...groups],
                    {
                        list: 'list',
                        groupName: 'name',
                        total: 'employees_total'
                    },
                    moreConfig,
                    config.nodeId
                )
                const result = Object.assign(res.data, {
                    list
                });
                resolve(result)
            })
        })
    }

    let isBigOrg = false
    try {
        isBigOrg = config.extendConfig.isBigOrgApi
    } catch (error) {
        console.warn("undfined isBigOrgApi")
    }
    if(isBigOrg){
        // 如果是大组织架构

         return getBigOrgTreeHandler(config, pageInfo, moreConfig);
    }

    return new Promise((resolve, reject) => {
        const data = {
            groupId: config.groupId
        };
        _getColleagueListById(data).then(
            res => {
                if (res.data.list && res.data.list.length) {
                    const newList = convertList(
                            res.data.list,
                            {
                                list: 'groupList',
                                groupName: 'name',
                                total: 'totalMember'
                            },
                            moreConfig,
                            config.nodeId
                        );
                    const result = Object.assign(res.data, {
                        list: newList,
                        isEnd: true
                    })
                    resolve(result);
                } else {
                    resolve({
                        list: []
                    });
                }
            },
            err => {
                reject(err);
            }
        );
    });
}

function _getColleagueListById(data) {
    return new Promise((resolve, reject) => {
        qdp.getColleagueListById({
            groupId: data.groupId,
            success(res) {
                resolve(res);
            },
            fail(res) {
                reject(res);
            }
        });
    });
}

function getOrgTree(depId = "0" ) {
    return Vue.prototype.$_sAjax.crossPost(`${envDomain.gateway}/v1/org/OrgTreeWithNum`, { depId, sub_dep_count: true });
}


function getBigOrgTreeFromJsapi(depId = "0" , index, count = 20) {
    return new Promise((resolve, reject) => {
        console.log(`[JSAPI][getOrgTree][REQ][deptId:${depId}][pageIndex:${index}]` )
        qdp.getOrgTree({
            depId,
            index,
            visable:{
                filter_disabled: true
            },
            count,
            success(res) {
                console.log("[JSAPI][getOrgTree][RSP]: ", res)
                res.code = 0
                resolve(res);
            },
            fail(res) {
                reject(res);
            }
        });
    });
}

function getBigOrgTreeHandler(config, pageInfo, moreConfig){
    return new Promise((resolve, reject) => {
        let reqIndex = pageInfo.index + 1
        // console.log('isBigOrg req page', pageInfo, reqIndex)
        try {


            getBigOrgTreeFromJsapi(config.parent.id, reqIndex, 20).then(async res=>{
                    if(res.code !== 0 ){
                        reject("组织架构数据获取失败", res.code)
                    }
                    let {deps, staffs, index, total_node, count} = res.data
                    let groups = deps.map(x=>{
                        return {
                            ...x,
                            list:[],
                            // memberTotal: 10
                        }
                    })
                    if(config.count === 0){
                        let groupsPromise = await deps.filter(x=>x.employees_total).map( async x=>{

                            let depChildren = await getBigOrgTreeHandlerNotFormate(x.id)
                            x.loaded = true

                            let listRes = [...depChildren.staffs, ...depChildren.deps ]
                            return {
                                ...x,
                                list: listRes,
                                // memberTotal: 10
                            }
                        })
                        groups = await  Promise.all(groupsPromise)
                    }
                    console.log(`[RSP][groups]:`,  groups)
                    let users = staffs.map(x=>{
                        return {
                            ...x,
                            colleagueInfo:{
                                account: x.account
                            },
                            id: x.kfext
                        }
                    })


                    moreConfig.transformGroup = function(item){
                        if(item.loaded === undefined) item.loaded = false
                        return item
                    }

                    if(config.count === 0){
                        moreConfig.totalState = true
                    }

                    let list = convertList(
                        [...users, ...groups],
                        {
                            list: 'list',
                            groupName: 'name',
                            total: 'employees_total'
                        },
                        moreConfig,
                        config.nodeId
                    )
                    console.log(`[RSP][list]:`, list)
                    const result = Object.assign(res.data, {
                        list
                    });


                    pageInfo.index = index
                    let end = true;
                    if (total_node && index < total_node / count) {
                        end = false;
                    }
                    pageInfo.end = end
                    result.pageInfo = pageInfo
                    result.isEnd = end
                    console.log("getBigOrgTreeFromJsapi res", result)
                    resolve(result)
                })

        } catch (error) {
            console.err("error in getBigOrgTreeHandler ", error)
        }
    })
}



function getBigOrgTreeHandlerNotFormate( pid ) {
    return new Promise(async (resolve, reject) => {
        let res = await getBigOrgTreeFromJsapi(pid, 1, 0);
        if(res.code !== 0 ){
            reject("组织架构数据获取失败", res.code)
        }
        let {deps, staffs} = res.data;

        let groupsPromise = await deps.filter(x=>x.employees_total).map( async x=>{

            let depChildren = await getBigOrgTreeHandlerNotFormate(x.id)
            x.loaded = true
            x.type = 'group'
            let listRes = [...depChildren.staffs, ...depChildren.deps ]
            return {
                ...x,
                list: listRes,
            }
        })

        let groups = await  Promise.all(groupsPromise)

        let users = staffs.map(x=>{
            return {
                ...x,
                colleagueInfo:{
                    account: x.account
                },
                id: x.kfext
            }
        })
        resolve({
            deps: groups,
            staffs: users
        })
    })

}


